import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./sk-Divider.module.css";
export const Divider = ({ className, orientation = "horizontal", onBackground = "light", ...restProps }) => {
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${onBackground}`]]: !!onBackground,
        [styles[`main--${orientation}`]]: !!orientation,
    });
    return _jsx("hr", { className: mainClassNames, ...restProps, "aria-orientation": orientation });
};
Divider.displayName = "Divider";
//# sourceMappingURL=Divider.js.map